import {isString} from '../lang/is';

const
    origin = () => {
        const
            {origin, protocol, hostname, port} = window.location;

        return (
            origin || (
                `${protocol}//${hostname}` +
                (port && !(
                    (protocol === 'https:' && port === '443') ||
                    (protocol === 'http:' && port === '80'))) ?
                    `:${port}` :
                    ''));
    },

    parse = url => {
        const
            [
                ,
                protocol = '',
                hostname = '',
                port = '',
                pathname = '',
                search = '',
                hash = ''
            ] = (
                /^(http:|https:)?(?:\/\/)?([^:/?#]+)?(?::(\d+))?([^?#]+)?([^#]+)?(.+)?$/
                .exec(url || ''));

        return {
            protocol,
            hostname,
            port,
            pathname,
            search,
            hash
        };
    },

    unparse = parts => {
        const
            {
                protocol = '',
                hostname = '',
                port = '',
                pathname = '',
                search = '',
                hash = ''
            } = parts;

        return (
            `${protocol}${protocol || hostname ? '//' : ''}` +
            `${hostname}${port ? ':' : ''}${port}` +
            `${pathname}${search}${hash}`);
    },

    isExternal = url => {
        const parsed = isString(url) ? parse(url) : url;

        return !!(
            parsed.hostname &&
            parsed.hostname !== window.location.hostname);
    },

    isInternal = url => {
        const parsed = isString(url) ? parse(url) : url;

        return !!((
            !parsed.hostname ||
            parsed.hostanem === window.location.hostname) && (

                !parsed.protocol ||
                parsed.protocol === window.location.protocol) && (

                parsed.pathname ||
                parsed.search));
    },

    isLocal = url => {
        const parsed = isString(url) ? parse(url) : url;

        return !isExternal(parsed) && !isInternal(parsed);
    };

export {
    origin,
    parse,
    unparse,
    isExternal,
    isInternal,
    isLocal
};
